import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../Auth/AuthProvider";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { VerifyPermission } from "../../Funcoes/VerifyPermission";
import axios from "axios";
import Tabela from "../../Componentes/Utils/Tabela";
import styled from "styled-components";
import ModalNewGHE from "./ModalNewGHE";
import { useModal } from "../../contexts/ModalContext";

const ColunaBody = styled.td`
    color: black;
`
const ColunaAdd = styled.td`
    background-color: #008600;
    color: white;
    font-weight: bold;
    text-align: center !important;
    cursor: pointer;
    transition: .3s;
    &:hover{
        background-color: #00b300;
    }
`

const ModalListaGHE = () => {

    const { user } = useContext(AuthContext);
    const { openModal, closeModal, isModalOpen } = useModal();

    const [ editId, setEditId ] = useState( null );
    const [ editGhe, setEditGhe ] = useState( null );

    const hasAccess = VerifyPermission(user, { modulo: 'ssma', submodulo: 'painel-ctrl', funcao: 'manage-ghe' })

    const [listaGHE, setListaGHE] = useState([])

    const fetchGHEList = async () => {

        if (!hasAccess) {

            return;

        }

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/InfoPanel/GHEList/');
            console.log(data);
            setListaGHE(data)

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {

        if (hasAccess) {

            fetchGHEList();

        }

    }, []);

    const openNewModal = ( id, ghe ) => {

        if( id && ghe ){

            setEditId( id );
            setEditGhe( ghe );

        }

        openModal("newGhe");

    }

    const successFunc = async () => {

        await fetchGHEList();
        closeModal();

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="xl" header={true} close={ closeModal } >
                    {
                        hasAccess ? (
                            <Tabela loading={false} >
                                <thead>
                                    <tr>
                                        <th>GHE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listaGHE.map((obj) => (
                                            <tr key={obj.id} onClick={() => openNewModal( obj.id, obj.nome ) } >
                                                <ColunaBody>{obj.nome}</ColunaBody>
                                            </tr>
                                        ))
                                    }
                                    <tr>
                                        <ColunaAdd onClick={() => openNewModal()} >NOVO GHE...</ColunaAdd>
                                    </tr>
                                </tbody>
                            </Tabela>
                        ) : (
                            <></>
                        )
                    }
                </Modal>
            </Overlay>
            {
                isModalOpen('newGhe') && (
                    <ModalNewGHE
                        id={ editId }
                        ghe={ editGhe }
                        onSuccess={ successFunc }
                    />
                )
            }
        </>
    )

}

export default ModalListaGHE;